import LabPersonsV2 from "./v2/LabPersons";

export default function LabPersons(props) {
  return <LabPersonsV2 {...props} />;
}
